<template>
    <Layout
        :header="{ text: titleText, backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } } }">
        <div class="pt-2 pb-6">
            <Process :steps="steps" :index="3" />
        </div>

        <div class="pb-8">
            <h2 class="font-bold text-2xl">
                預約視訊時間
            </h2>
            <p class="pt-2">
                {{ userData.targetDesc }}
            </p>
        </div>

        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">
                視訊日期
            </h3>
            <OptionBox :inputOption="option" inputType="radio" :inputValue="userData.dateOptions.inputValue"
                :setInputValue="(data) => { selectDate(data); }" v-for="option in userData.dateOptions.inputOptions" />
        </div>
        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">
                視訊時間
            </h3>
            <selectBox :timeValue="userData.timeOptions.timeValue" :setTimeValue="setTimeValue" placeholder="請選擇視訊時間"
                :boxData="userData.timeOptions" />
        </div>
        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="userData.dateOptions.inputValue === '' || userData.timeOptions.timeValue === ''"
                @click="submit">下一步</button>
        </template>
        <Loading :is-loading="isLoading" />
        <InfoBox v-if="errorBoxVisble" :closeHandel="closeBox" title="系統提示">
            <div v-html="errorMessage" />
        </InfoBox>
    </Layout>
</template>

<script setup>
import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import Loading from '@/components/Loading.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue'
import OptionBox from '@/components/cloudCounter/OptionBox.vue';
import selectBox from '@/components/cloudCounter/SelectBox.vue';

// import '@/assets/cloudCounter/css/style.css';
import { ref, reactive, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import routeName from '@/router/constant.js';
import { getPeriod, postPeriod } from '@/apis/CloudECounter';
import aplCatlCode from '@/json/aplCatlCode';

const router = useRouter();
const store = useStore();
const dateSelect = ref('');
const periodSelect = ref('');
const titleText = ref('');
const errorMessage = ref('');
const isLoading = ref(false);
const errorBoxVisble = ref(false);
const userData = reactive({
    targetDesc: '',
    // 日期選單情境
    dateOptions: {
        inputValue: '',
        inputOptions: []
    },
    timeOptions: {
        boxTitle: '請選擇視訊時間',
        timeValue: '',
        timeNo: '',
        options: []
    },
    allTimeOption: [],
    // periodOption: [],
    errors: {
        dateSelectError: '',
        periodSelectError: '',
    }
});
const steps = ref(['選擇保單', '填寫資料', '確認資料', '視訊預約',]);

const aplCatl = computed(() => store.state.services.aplCatl);
if (aplCatl.value === aplCatlCode.BENEIFCIARY) {
    titleText.value = '受益人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_CHANGE) {
    titleText.value = '要保人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_INSURED_NAME_CHANGE) {
    titleText.value = '要保人或被保險人姓名變更'
} else if (aplCatl.value === aplCatlCode.LOAN) {
    titleText.value = '保單借款'
    steps.value = ['同意條款', '選擇保單', '確認資料', '手機驗證',];
}

const submit = () => {

    const flag = ref(false);

    if (!userData.dateOptions.inputValue) {
        userData.errors.dateSelectError = '請選擇日期';
        flag.value = true;
    }
    if (!userData.timeOptions.timeValue) {
        userData.errors.periodSelectError = '請選擇時段';
        flag.value = true;
    }

    if (!flag.value) {
        goNextPage();
    }

}


const goNextPage = () => {
    isLoading.value = true;
    const returnData = {
        reserveDate: userData.dateOptions.inputValue,
        reserveTimeNo: userData.timeOptions.timeNo
    };

    postPeriod(returnData).then(res => {
        if (res.success) {
            const nextRouteName = routeName.CLOUD_E_COUNTER_APPLY_OTP;
            router.push({ name: nextRouteName });
        }
    }).catch(e => {
        console.log(e.data.errorCode);
    }).finally(() => {
        isLoading.value = false;
    });

};



/** 取得頁面資料 */
const getData = () => {
    getPeriod().then(res => {
        if (res.data.periodDateList) {
            userData.dateOptions.inputOptions = res.data.periodDateList.map(i => {
                const obj = ref({});
                obj.title = i.date;
                obj.optionValue = i.date;
                obj.disabled = (i.status === 'N');
                return obj;
            });
        }
        if (res.data.periodTimeList) {
            userData.allTimeOption = res.data.periodTimeList.map(i => {
                i.value = i.no;
                // i.label = i.date + '  ' + i.text;
                i.label = i.text;
                i.disabled = (i.status === 'N');
                return i;
            });
        }
        userData.targetDesc = res.data.targetDesc;
    });
};
const selectDate = (item) => {
    // userData.periodOption = userData.allTimeOption.filter(i => i.date === item);
    userData.dateOptions.inputValue = item;
    userData.timeOptions.options = userData.allTimeOption.filter(i => i.date === item).map(i => {
        const obj = ref({});
        obj.value = i.label;
        obj.no = i.no;
        obj.disabled = i.disabled;
        return obj;
    });
};
const setTimeValue = (data) => {
    userData.timeOptions.timeValue = data.value;
    userData.timeOptions.options.filter(i => {
        if (i.value === data.value) {
            userData.timeOptions.timeNo = i.no;
        }
    });
};

getData();


</script>
